<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="false"
                                id="ms"
                                size="xl"
                                title="Verlonen">

  <snelstart-ui-dialog-body [padding]="0">
    <snelstart-ui-tab>
      <snelstart-ui-tab-item
        (click)="onSelectTab(1)"
        [isActive]="(selectedPeriode$ | async) === 1"
        id="Tab1"
      >
        Januari
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(2)"
        [isActive]="(selectedPeriode$ | async) === 2"
        id="Tab2"
      >
        Februari
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(3)"
        [isActive]="(selectedPeriode$ | async) === 3"
        id="Tab3"
      >
        Maart
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(4)"
        [isActive]="(selectedPeriode$ | async) === 4"
        id="Tab4"
      >
        April
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(5)"
        [isActive]="(selectedPeriode$ | async) === 5"
        id="Tab5"
      >
        Mei
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(6)"
        [isActive]="(selectedPeriode$ | async) === 6"
        id="Tab6"
      >
        Juni
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(7)"
        [isActive]="(selectedPeriode$ | async) === 7"
        id="Tab7"
      >
        Juli
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(8)"
        [isActive]="(selectedPeriode$ | async) === 8"
        id="Tab8"
      >
        Augustus
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(9)"
        [isActive]="(selectedPeriode$ | async) === 9"
        id="Tab9"
      >
        September
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(10)"
        [isActive]="(selectedPeriode$ | async) === 10"
        id="Tab10"
      >
        Oktober
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(11)"
        [isActive]="(selectedPeriode$ | async) === 11"
        id="Tab11"
      >
        November
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(12)"
        [isActive]="(selectedPeriode$ | async) === 12"
        id="Tab12"
      >
        December
      </snelstart-ui-tab-item>
    </snelstart-ui-tab>

    @if ((werkgeverEntity$ | async) && (selectedPeriode$ | async)) {
      @if (view === 'Verlonen') {
        <snelstart-ui-tab-content>
          <form [formGroup]="loonjournaalFg">
            <snelstart-ui-date-form-control [disabledControl]="true"
                                            class="custom-input-270"
                                            formControlName="uitersteBetaaldatum"
                                            id="uitersteBetaaldatum"
                                            label="Uiterste betaaldatum">
            </snelstart-ui-date-form-control>
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-270"
                                            formControlName="betalingskenmerk"
                                            id="betalingskenmerk"
                                            label="Betalingskenmerk">
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="true"
                                              align="right"
                                              class="custom-input-270"
                                              formControlName="teBetalen"
                                              id="teBetalen"
                                              label="Te betalen"
                                              prefix="€">
            </snelstart-ui-number-form-control>
          </form>
        </snelstart-ui-tab-content>
      } @else if (view === 'Netto loon') {
        <snelstart-ui-tab-content>
          <form [formGroup]="loonjournaalFg">
            @if (loonJournaal.nettoLonen?.length !== 0) {
                <div formArrayName="nettoLonen">
                  @for (item of nettoLonen.controls; let i = $index; track $index) {
                    <div [formGroupName]="i">
                      <div class="row mb-0.5">
                        <div class="col-auto">
                          <snelstart-ui-text-form-control [disabledControl]="true"
                                                          [label]="i === 0 ? 'Naam werknemer' : ''"
                                                          class="custom-input-270"
                                                          formControlName="omschrijving"
                                                          id="omschrijving">
                          </snelstart-ui-text-form-control>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-iban-form-control [disabledControl]="true"
                                                          [label]="i === 0 ? 'IBAN' : ''"
                                                          class="custom-input-270"
                                                          formControlName="grootboeknummer"
                                                          id="grootboeknummer">
                          </snelstart-ui-iban-form-control>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control [disabledControl]="true"
                                                            [label]="i === 0 ? 'Netto loon' : ''"
                                                            [prefix]="'€'"
                                                            [showAllDecimals]="true"
                                                            align="right"
                                                            class="custom-input-150"
                                                            formControlName="bedragDebet">
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                    </div>
                  }
                </div>
            }
          </form>
        </snelstart-ui-tab-content>
      } @else if (view === 'Journaalposten') {
        <snelstart-ui-tab-content>
          <form [formGroup]="resultFg">
              <div formArrayName="results">
                @for (item of results.controls; let i = $index; track $index) {
                  <div [formGroupName]="i">
                    <div class="row mb-0.5">
                      <div class="col-auto">
                        <snelstart-ui-text-form-control [disabledControl]="true"
                                                        [label]="i === 0 ? 'Grootboekomschrijving' : ''"
                                                        class="custom-input-250"
                                                        formControlName="omschrijving"
                                                        id="omschrijving"
                        >
                        </snelstart-ui-text-form-control>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-text-form-control [disabledControl]="true"
                                                        [label]="i === 0 ? 'Grootboeknummer' : ''"
                                                        class="custom-input-150"
                                                        formControlName="grootboeknummer"
                                                        id="grootboeknummer"
                        >
                        </snelstart-ui-text-form-control>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control [disabledControl]="true"
                                                          [label]="i === 0 ? 'Debet' : ''"
                                                          [showAllDecimals]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="bedragDebet"
                                                          id="bedragDebet"
                                                          prefix="€">
                        </snelstart-ui-number-form-control>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control [disabledControl]="true"
                                                          [label]="i === 0 ? 'Credit' : ''"
                                                          [showAllDecimals]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="bedragCredit"
                                                          id="bedragCredit"
                                                          prefix="€">
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  </div>
                }
              </div>

            <div class="row mb-0.5">

              <div class="col-auto">
                <div class="custom-input-250"></div>
              </div>

              <div class="col-auto">
                <div class="custom-input-150"></div>
              </div>

              <div class="col-auto">
                <snelstart-ui-number-form-control
                  [calculate]="totalAmountDebet()"
                  [disabledControl]="true"
                  [showAllDecimals]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="totalBedragDebet"
                  id="totalBedragDebet"
                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>

              <div class="col-auto">
                <snelstart-ui-number-form-control
                  [calculate]="totalAmountCredit()"
                  [disabledControl]="true"
                  [showAllDecimals]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="totalBedragCredit"
                  id="totalBedragCredit"
                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>
            </div>
          </form>
        </snelstart-ui-tab-content>
      }
    }

    @if ((werknemerList$ | async)?.length === 0) {
      <snelstart-ui-tab-content>
        <snelstart-ui-alert type="info">Er zijn nog geen werknemers ingevuld. Als er op de button Indienen wordt
          geklikt, wordt een nihilaangifte verzonden naar de Belastingdienst.
        </snelstart-ui-alert>
      </snelstart-ui-tab-content>
    }
  </snelstart-ui-dialog-body>

  @if (view === 'Verlonen') {
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                           type="secondary">
        Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button [config]="verzendLoonaangifte" [disabled]="false" icon="check" id="save" type="primary">
        Indienen
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  }
  @if (view === 'Netto loon') {
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button
        (click)="this.genereerPdfNettoLonen()"
        class="me-2"
        icon="file-pdf"
        id="genereerPdfNettoLonen"
        type="link">
        Pdf genereren
      </snelstart-ui-button>

      <snelstart-ui-button
        (click)="this.dialogVisibleChange.emit(false)"
        btn-x
        icon="check"
        id="save"
        type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  }
  @if (view === 'Journaalposten') {
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button (click)="dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                           type="secondary">
        Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button [config]="journalPost" [disabled]="!hasAdmin || (werknemerList$ | async)?.length === 0"
                           icon="memo-circle-check"
                           id="save" type="primary">
        Boeken journaalpost {{ selectedPeriodeSalaris().toLowerCase() }}
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  }

</snelstart-ui-dialog-definition>

